import Barcode from "react-barcode";
import logo from "../../../../../logo.svg";

import { signInUser } from "../../../../Utility/Auth";
import { resolvePhotoUrl } from "../../../../Utility/resolvePhotoUrl";

const GrnHeader = ({ grn, format, title }) => {
  const auth = signInUser();
  const { storeSettings } = auth;

  return (
    <>
      <div className="row  pb-3 mb-2 border-bottom">
        <div className="col-7">
          <img
            src={resolvePhotoUrl(
              storeSettings?.storePhoto || storeSettings?.photo,
              logo
            )}
            onError={(e) => {
              e.target.src = logo;
            }}
            height="40"
            alt="not Image"
          />
        </div>

        <div className="col-5">
          <p className="p-0 m-0 text-end">
            <b>Hotline: </b> {storeSettings?.phone || "01700000000"}
          </p>
          <p className="p-0 m-0 text-end">
            <small>{grn?.warehouse?.name}</small>{" "}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-6 print-header-text">
          <p>
            <b>Name of Supplier:</b>
            <br />
            {grn?.supplier?.company} <br />
            {grn?.supplier?.email} <br />
            {grn?.supplier?.phone} <br />
            {grn?.supplier?.address} <br />
          </p>
          <p>
            <b>Warehouse:</b> <br />
            {storeSettings?.storeName || "No-Name"} <br />
            {storeSettings?.email || "No-Email"}
            <br />
            {storeSettings?.phone || "01700000000"}
            <br />
            {storeSettings?.address?.street || "No-Street"} ,
            {storeSettings?.address?.city || "No-City"},{" "}
            {storeSettings?.address?.state || "No-State"},{" "}
            {storeSettings?.address?.post || "No-PostalCode"} <br />
          </p>
        </div>
        <div className="col-6 text-end">
          {/* {console.log(grn?.print)} */}
          {!grn?.print ? <h4>[ORIGINAL]</h4> : <h4>[DUPLICATE]</h4>}
          <h4>{title}</h4>
          <span className="ps-6 d-block">
            <p>
              <b>GRN No:</b> {grn?.grnNo}
              <br />
              <b>GRN Date:</b>{" "}
              {grn?.createdAt && format(new Date(grn?.createdAt), "yyyy-MM-dd")}{" "}
              <br />
              <b>PO No:</b> {grn?.poNo?.poNo}
              <br />
              <b>PO Date:</b>{" "}
              {grn?.createdAt && format(new Date(grn?.createdAt), "yyyy-MM-dd")}{" "}
              <br />
              {grn?.voucherNo?.length > 0 ? (
                <>
                  <b>Voucher No: </b> {grn?.voucherNo}
                </>
              ) : (
                <></>
              )}
              <br />
              {grn?.voucherDate ? (
                <>
                  <b>Voucher Date: </b>
                  {format(new Date(grn?.voucherDate), "yyyy-MM-dd")}
                </>
              ) : (
                <></>
              )}
              <p className="text-end  ">
                <Barcode  value={grn?._id} height="40" width="1" fontSize="10" />
              </p>
            </p>
          </span>
        </div>
      </div>
    </>
  );
};

export default GrnHeader;
